import { render } from "./ButtonDemo.vue?vue&type=template&id=3c2eca2b"
import script from "./ButtonDemo.vue?vue&type=script&lang=js"
export * from "./ButtonDemo.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/eAzC_LUi/0/econsultingsistemas/certificadorweb/certificador-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__